import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import {
  RELATED_PARTY_RELATIONSHIP,
  RELATED_PARTY_TYPES,
} from '../../../../../../../constants';

const {
  formField: { principalCertificateOfTrust, principalType },
} = loanFormModel;

export class PrincipalCertificateOfTrustValidation implements ValidationSchema {
  public name = principalCertificateOfTrust.name;
  public label = '';
  public dependsOn: string[] = [];
  public type = 'object';
  public required = {
    message: 'This document is required',
    value: false,
  };
  public nullable = true;

  public when(schema) {
    return schema.test(
      'check-required-if-undefined',
      'This document is required',
      function () {
        const documentObject = this.from[1].value;
        const principalTypeValue = (this as any).from[3].value[
          principalType.name
        ];
        const principalRelationship = (this as any).from[3].value[
          'relationship'
        ];
        // this.from[3] traverses back up the object tree to the principal so that we can read principal_type
        if (
          principalTypeValue === RELATED_PARTY_TYPES.ENTITY &&
          principalRelationship !== RELATED_PARTY_RELATIONSHIP.LANDLORD
        ) {
          if (!documentObject || !documentObject.files) {
            return false;
          }

          return !!(
            documentObject.files[0]?.file_name != null &&
            documentObject.files[0]?.file_name !== ''
          );
        }
        return true;
      }
    );
  }
}
export default new Validation(new PrincipalCertificateOfTrustValidation());
